import { RecordType } from "../Models/tableDetailsModel";

export const isSsnUnlocked = (record: RecordType) => {
    return record.isSsnLocked === false &&
        record.selfSsnLockedDetails?.unlockedOn !== null &&
        record.selfSsnLockedDetails?.unlockedBy !== null &&
        record.isUnlockedThroughSsn === false;
}

export const getShouldRenderLockUnlockHeader = (
    record: RecordType,
): boolean => {
    const isApplicationLocked = Boolean(record.isLocked);
    const isApplicationUnlocked = Boolean(record.isManuallyUnlocked);
    const isSsnLocked = Boolean(record.isSsnLocked);
    const isSsnUnlockedFlag = isSsnUnlocked(record);
    const isUnlockedThroughSsn =
        Boolean(record.isUnlockedThroughSsn) &&
        Boolean(record.benefitedSsnApplicationDetails?.lockedOpportunity);

    return (
        isApplicationLocked ||
        isApplicationUnlocked ||
        isSsnLocked ||
        isSsnUnlockedFlag ||
        isUnlockedThroughSsn
    );
};